module.exports = __webpack_public_path__ + "static/media/kids_reading_yellow.0371d2f5.png";